<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">Organizacje</h3>
        <div class="d-flex flex-row gap-3">
                <mat-form-field appearance="outline">
                    <mat-label style="color: gray;">Szukaj...</mat-label>
                    <input matInput [formControl]="filter">
                </mat-form-field>
        </div>
        <div class="d-flex flex-row gap-3 flex-fill justify-content-end">
             <button mat-flat-button class="btn-with-icon big-button" color="accent"
                    (click)="router.navigate(['create-organization'])">
                    <mat-icon class="big-icon">add</mat-icon> Dodaj organizację</button>
                <button mat-flat-button color="accent" class="big-button" (click)="fetchOrganizations()">
                    <mat-icon class="big-icon m-0">refresh</mat-icon>
                </button>
        </div>
    </div>

    <mat-card class="list-container">
        <mat-card-content>
            <div class="cards-container">
                <app-organization-card *ngFor="let item of filteredOrganizations$ | async"
                    [organization]="item"></app-organization-card>
            </div>
        </mat-card-content>
    </mat-card>

    <div style="height:50px">

    </div>
</div>